import React from 'react'
import PropTypes from 'prop-types'
import Message from './Message'

function MessageList({ messages, suggestions, onSuggestion, conversationId }) {
  if (!messages || messages.length === 0) {
    if (suggestions && onSuggestion) {
      return (
        <div className="ai-messages-empty">
          <p>Start a conversation by asking a question.</p>
          <div className="ai-suggestion-chips">
            {suggestions.map((text) => (
              <button key={text} type="button" className="ai-suggestion-chip" onClick={() => onSuggestion(text)}>
                {text}
              </button>
            ))}
          </div>
        </div>
      )
    }

    return (
      <div className="ai-messages-empty">
        <p>Start a conversation by asking a question about your data.</p>
        <p className="ai-messages-hint">
          Try asking things like:
        </p>
        <ul className="ai-suggestions">
          <li>"How many jobs are in progress?"</li>
          <li>"What equipment needs calibration soon?"</li>
          <li>"Show me the last 5 completed jobs"</li>
          <li>"Which samples were created this week?"</li>
        </ul>
      </div>
    )
  }

  return (
    <div className="ai-messages-list">
      {messages.map((message) => (
        <Message key={message.id} message={message} conversationId={conversationId} />
      ))}
    </div>
  )
}

MessageList.propTypes = {
  messages: PropTypes.array,
  suggestions: PropTypes.array,
  onSuggestion: PropTypes.func,
  conversationId: PropTypes.number
}

export default MessageList
